export default __webpack_public_path__ + "img/t1.af0dbb90.png";